import React, { useState } from "react";
import DatePicker from "react-datepicker";

const NewTimetable = ({ onSubmit, onCancel }) => {
    const [from, setFrom] = useState(new Date());
    const [to, setTo] = useState(from);
    return (
        <form
            method="POST"
            onSubmit={(event) => {
                event.preventDefault();
                onSubmit({
                    start: from,
                    end: to,
                });

                setFrom(new Date());
                setTo(from);
            }}
        >
            <div className="form-group">
                <label htmlFor="description-id">Start Date & Time</label>
                <DatePicker
                    selected={from}
                    onChange={(date) => setFrom(date)}
                    className="form-control input-height"
                    timeIntervals={5}
                    showTimeSelect
                    timeCaption="Time"
                    dateFormat="MMM d, yyyy h:mm aa"
                />
            </div>
            <div className="form-group">
                <label htmlFor="description-id">End Date & Time</label>
                <DatePicker
                    selected={to}
                    onChange={(date) => setTo(date)}
                    className="form-control input-height"
                    timeIntervals={15}
                    showTimeSelect
                    timeCaption="Time"
                    dateFormat="MMM d, yyyy h:mm aa"
                />
            </div>

            <div className="text-center">
                <button type="submit" className="mdl-button mdl-button--raised mdl-js-ripple-effect m-b-10 margin-right-10 btn-circle btn-success">
                    Save Timetable
                    <i className="material-icons">arrow_right_alt</i>
                </button>
                <button type="button" onClick={onCancel} className="mdl-button mdl-button--raised mdl-js-ripple-effect m-b-10 margin-left-10 btn-circle btn-default">
                    <i className="material-icons text-danger">cancel</i> Cancel
                </button>
            </div>
        </form>
    );
};

export default NewTimetable;
